import { Component } from '@angular/core';
import { OnInit } from '@angular/core';
//import { Router } from "@angular/router";
import { AuthService } from '../../../auth/auth.service';
import { environment } from '../../../environments/environment';
import { Observable, from } from 'rxjs';
import { AuthMsgService } from '../../../auth/auth-msg.service';
import { ImportsService } from './imports.service';

export class ViewModel {

  "importId": string;
  "responseCallbackEnabled": boolean;
  "totalUploadedRecords": number;
}

export class ViewModelUpsert {
  "create": ViewModel;
  "update": ViewModel;
}


export class ImportRecord {
  createdDateTime: Date;
  createdBy: string;
  modifiedDateTime: Date;
  modifiedBy: string;
  status: string;
  externalId: string;
  details: string;
  id: string;
}

export class CloudFile {
  containerName: string;
  path: string;
  name: string;
  dateAdded: Date;
  type: string;
  location: string;
}

export class ImportResults {
  createdDateTime: Date;
  createdBy: string;
  modifiedDateTime: Date;
  modifiedBy: string;
  importRecords: ImportRecord[];
  status: string;
  importType: string;
  processingStartedAt: Date
  processingCompletedAt: Date;
  cloudFile: CloudFile;
  totalProcessingTime: string;
  id: string;
}


@Component({
    selector: 'imports',
    templateUrl: './imports.component.html'
})
export class ImportsComponent implements OnInit  {

  public InputJson: string = '';
  public Response: any;
  public Results: ImportResults = new ImportResults();
  public Results1: ImportResults = new ImportResults();
  public DisplayViewResults: boolean = false;
  public DisplayViewResults1: boolean = false;
  public DisplayButtonResults: boolean = false;
  public DisplayButtonImport: boolean = true;
  public messageErr: string = "";
  public ShowErr: boolean = false;
  public ShowLoading: boolean = true;
  public ShowForm: boolean = false;
  public ImportType: number = 1;
  public includeItems: boolean = true;

  constructor(private authService: AuthService,
    private authMsgService: AuthMsgService, private importsService: ImportsService) {


  }


  ngOnInit(): void {    
    this.initComponent(this.authService.isLoggedIn());
  }

  private initComponent(isLoggedIn: boolean): void {
    this.authMsgService.sendMessage(isLoggedIn);
    this.DisplayButtonResults = false;
    this.DisplayButtonImport = true;
    this.ShowLoading = false;
    this.ShowForm = true;
  }



  onViewResultClick(): void {

    this.ShowLoading = true;
    this.ShowForm = false;
    this.messageErr = "";

    var importId = "";
    if (this.ImportType == 4) {
      importId = this.Response.create.importId;
    }
    else {
      importId = this.Response.importId;
    }

    if (environment.debug_mode) {
      console.log("onViewResultClick, importId:" + importId);
    }

    if (importId != '') {

      this.importsService.getResults(importId, this.includeItems)
        .subscribe(
          (response: ImportResults) => {

            this.Results = response;
            this.DisplayViewResults = true;
            this.ShowLoading = false;
            this.ShowForm = true;

            if (environment.debug_mode) {
              //console.log("Results, " + JSON.stringify(this.Results));
            }

          }

          ,
          (error) => {


            console.error(error);
            this.ShowErr = true;
            this.messageErr = <string>error.message;
            this.ShowLoading = false;
            this.ShowForm = true;

          }
        );
    }

    if (this.ImportType == 4) {

      if (environment.debug_mode) {
        console.log("onViewResultClick, Response.update.importId:" + this.Response.update.importId);
      }

      if (this.Response.update.importId != '') {

        this.importsService.getResults(this.Response.update.importId, this.includeItems)
          .subscribe(
            (response: ImportResults) => {

              this.Results1 = response;
              this.DisplayViewResults1 = true;
              this.ShowLoading = false;
              this.ShowForm = true;

              if (environment.debug_mode) {
                //console.log("Results, " + JSON.stringify(this.Results));
              }

            }

            ,
            (error) => {


              console.error(error);
              this.ShowErr = true;
              this.messageErr = <string>error.message;
              this.ShowLoading = false;
              this.ShowForm = true;

            }
          );

      }

    }

  }

  onImportClick(): void {


    this.DisplayViewResults = false;
    this.DisplayButtonResults = false;
    this.DisplayViewResults1 = false;
    this.messageErr = "";


    this.ShowLoading = true;
    this.ShowForm = false;

    this.importsService.postJson(this.InputJson, this.ImportType)
      .subscribe(
      (response: any) => {

          this.Response = response;

          if (environment.debug_mode) {
            console.log("postJson, response: " + JSON.stringify(response));
          }

          this.DisplayButtonResults = true;
          this.DisplayButtonImport = true;
          this.ShowLoading = false;
          this.ShowForm = true;

        }

        ,
        (error) => {


          console.error(error);
          this.ShowErr = true;
          this.messageErr = <string>error.message;
          this.ShowLoading = false;
          this.ShowForm = true;

        }
      );

    //Display Link where to get Import Results
  }

}
